/**
 * InstamapsLayers 
 * 
 * require todos los archivos con los diferentes tipos de capas
 * require geocat.mapa.wms
 * require geocat.mapa.json
 * require geocat.mapa.tematic
 * require geocat.mapa.url-file
 * require geocat.mapa.geojsonvt
 * require geocat.mapa.dades-obertes
 * require geocat.mapa.xarxes-socials
 * require geocat.mapa.heat
 * require geocat.mapa.cluster
 * require geocat.mapa.visualitzacioWMS
 */
;(function(global, $){

	var instamapsLayers = null;

	var InstamapsLayers = function(options){
		if (null === instamapsLayers){
			instamapsLayers = new InstamapsLayers.init(options);
		}
		return instamapsLayers;
	};

	var layersOptions = {
		layers: []
	};
	
	InstamapsLayers.prototype = {
		setLayerInfo: function(base, businessId, capesOrdre) {
			var self = this;
			var layer = base;

			if(layer && businessId) {
			
				layer.businessId = businessId;

			}

			if(layer && capesOrdre && 'sublayer' === capesOrdre) {

				layer.sublayer = true;

			} else if(layer) {

				layer.sublayer = false;

			}

			return layer;

		},
		loadLayer: function(value, optionsMare){
			var self = this,
			_map = self.map,
			layer = {},
			defer = $.Deferred();
			var propsCapaMare = InstamapsUtils.Dom.cleanOptions(optionsMare);
			if (value.epsg === "4326" || value.epsg === "EPSG:4326"){
				value.epsg = L.CRS.EPSG4326;
			}else if (value.epsg === "25831" || value.epsg === "EPSG:25831"){
				value.epsg = L.CRS.EPSG25831;
			}else if (value.epsg === "23031" || value.epsg === "EPSG:23031"){
				value.epsg = L.CRS.EPSG23031;
			}else{
				value.epsg = _map.options.crs;
			}
			//TODO igualar todos los metodos de carga de capas para que sean asyn y retornen un promise

			//Si la capa es de tipus wms
			if(value.serverType == t_wms){
				//TODO ver si se puede sacar el mapa
				loadWmsLayer(value, _map).then(function(result){
					layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
					defer.resolve(layer);
				});
			//Si la capa es de tipus dades obertes
			}else if(value.serverType == t_json){
				loadCapaFromJSON(value).then(function(result){
					layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
					defer.resolve(layer);
				});
			//Si la capa es de tipus url file
			}else if(value.serverType == t_url_file){
				loadURLfileLayer(value,optionsMare).then(function(result){
					layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
					defer.resolve(layer);
				},function(result){
					defer.reject(result);
				});
			//Si la capa es de tipus GeojsonvtLayer
			}else if(value.serverType == t_geojsonvt){
				//console.debug(loadGeojsonvtLayer);
				layer = loadGeojsonvtLayer(value);
				layer = self.setLayerInfo(layer, value.businessId, value.capesOrdre);
				defer.resolve(layer);
			//Si la capa es de tipus dades obertes
			}else if(value.serverType == t_dades_obertes){
				loadDadesObertesLayer(value).then(function(result){
					layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
					defer.resolve(layer);
				},function(result){
					defer.reject(result);
				});
			//Si la capa es de tipus xarxes socials
			}else if(value.serverType == t_xarxes_socials){
				var options = $.parseJSON( value.options );
				if(options.xarxa_social == 'twitter'){
					layer = loadTwitterLayer(value, options.hashtag);
				}
				else if(options.xarxa_social == 'wikipedia') {
					layer = loadWikipediaLayer(value);
				}
				layer = self.setLayerInfo(layer, value.businessId, value.capesOrdre);
				defer.resolve(layer);
			}else if(value.serverType == t_visualitzacio){
				if (self.edit) {
					loadVisualitzacioLayer(value).then(function(result){
						layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
						defer.resolve(layer);
					});
				}
				else {
					var optionsL = InstamapsUtils.Dom.cleanOptions(value.options);
					if (propsCapaMare!="" && propsCapaMare!=undefined){
							var optionsL2 = InstamapsUtils.Dom.cleanOptions(optionsL.options);
							optionsL2["propFormat"] = propsCapaMare.propFormat;
							optionsL2["propPrivacitat"] = propsCapaMare.propPrivacitat;
							optionsL2["propImatge"] = propsCapaMare.propImatge;
							optionsL2["propIcona"] = propsCapaMare.propIcona;
							optionsL2["campPrincipal"] = propsCapaMare.campPrincipal;
							optionsL.options = optionsL2;
							value.options = optionsL;						
					}
					
					loadCacheVisualitzacioLayer(value).then(function(result){
						layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
						defer.resolve(layer);
					});	
				}
			//Si la capa es de tipus vis_wms
			}else if(value.serverType == t_vis_wms || value.serverType == t_vis_wms_noedit){
				loadVisualitzacioWmsLayer(value).then(function(result) {
					layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
					defer.resolve(layer);
				});
			}
			else if(value.serverType == tem_heatmap_wms || value.serverType == tem_cluster_wms){
				loadVisualitzacioWmsLayerSenseUtfGrid(value).then(function(result) {
					layer = self.setLayerInfo(result, value.businessId, value.capesOrdre);
					defer.resolve(layer);
				});
			}else{
				console.error("Tipus capa no soportat");
				defer.reject({msg:"Tipus capa no soportat"});
			}
			return defer.promise();
		},
		
		_loadAllLayers: function(_mapConfig, _controlCapes){
			var self = this,
			dfd = $.Deferred();
			self.waitDeferred = dfd;
			self._loadOrigenWMS(_mapConfig, _controlCapes).then(function(results){
				var num_origen = 0;
				self.numLayers = results.origen.length + results.sublayers.length;
				if(self.numLayers === 0){
					self._waitLoadAll(0);
				}
				if (!self.edit){
					self.map.oms = new OverlappingMarkerSpiderfier(self.map, {keepSpiderfied :true});
					self.map.oms.addListener('click', function(marker) {
						console.log("click feature");
						var event = {
							latlng: marker._latlng,
							containerPoint: self.map.latLngToContainerPoint(marker._latlng)
						};
						$.publish('createPopupOnclick', {event: event, element: marker});
					});
					
					self.map.oms.addListener('spiderfy', function(spiderified_center, spiderified, unspiderified) {
						
						
						var features = [];
						for (var i = spiderified.length - 1; i >= 0; i--) {
							var origen = self._getLayerByBussinesId(spiderified[i].marker.properties.capaOrigen);
							var feature = spiderified[i].marker.properties.feature;
							if(origen && origen.layer && origen.layer.options && origen.layer.options.nom)
								feature.properties.capaNom = origen.layer.options.nom;
							features.push(feature);
						}
						var event = {
							latlng: spiderified_center[0]._omsData.usualPosition,
							containerPoint: self.map.latLngToContainerPoint(spiderified_center[0]._omsData.usualPosition),
							elements: features
						};
						//TODO ver como pasar todos los elementos del spiderfy 
						//ahora solo coge los que están mas cerca del click
						$.publish('createPopupOnclick', {event: event, element: spiderified_center[0]});
					});
				}
				$.each(results.origen, function(index, value){
						self.loadLayer(value).then(function(layer){
							var optionsMare;
							if (layer.layer!==undefined && layer.layer.options!==undefined) {
								optionsMare = layer.layer.options;
							} 
							if(layer.layer && layer.layer.options
								&& layer.layer.options.tipus !== "wms")
								Object.freeze(layer.layer._layers);
							self.layers.push(layer);
							num_origen = self._loadLayerAddOriginWait(num_origen);
							if (num_origen == results.origen.length){
								$.each(results.sublayers, function(index, value){
									self.loadLayer(value,optionsMare).then(
										function(layer){
											if(layer.layer && layer.layer.options
												&& layer.layer.options.tipus !== "wms")
												Object.freeze(layer.layer._layers);
											self.layers.push(layer);
											num_origen = self._loadLayerAddOriginWait(num_origen);
										},
										function(){
											num_origen = self._loadLayerAddOriginWait(num_origen);
										}
									);
								});
							}
						},function(){
							num_origen = self._loadLayerAddOriginWait(num_origen);
						});
					});				
			});
			//dfd.resolve();
			return dfd.promise();
		},
		
		_loadLayerAddOriginWait: function(num_origen){
			var self = this;
			num_origen++;
			self._waitLoadAll(num_origen);
			return num_origen;
		},

		_toggleLayer: function(e, layerBussinesid){
			e.preventDefault();
			e.stopImmediatePropagation();
			var self = this;			
 			$.each(self.layers, function(index, value) {
				var currentLayer = value.layer;
 				if(currentLayer){
 					if(layerBussinesid === currentLayer.options.businessId){
	 					if(value.activa){
							value.activa = false;
							for (var i in currentLayer._layers) {
								var sublayer = currentLayer._layers[i];
								sublayer.activa = false;
								map.removeLayer(sublayer);
							}
							 map.removeLayer(currentLayer);
							/* map.on('click', function(e) {
								$.publish('createPopupOnclick', {event: e});
							});*/ 
	 						return false;
	 					}else{
							value.activa = true;							
							 map.addLayer(currentLayer);
							 /*map.on('click', function(e) {
								$.publish('createPopupOnclick', {event: e}); 
							});*/
							for (var i in currentLayer._layers) {
								var sublayer = currentLayer._layers[i];
								sublayer.activa = true;
								map.addLayer(sublayer);
							} 
	 						return false;
	 					}
	 				}
 				}
			});
			$.publish('updateVisualitzacioLeafletLayer', {layers: self.layers});			
 			return self;
		},

		_toggleSubCapa: function(e, capa) {
			console.log(capa);
			e.preventDefault();
			e.stopImmediatePropagation();
			var self = this;
			var layers = self.layers;
			var currentLayer = _.find(layers, { businessId: capa.layer });
			var subLayersState = [];
            for (var i in currentLayer.layer._layers) {
                var sublayer = currentLayer.layer._layers[i];
				if (sublayer.properties!==undefined && sublayer.properties.estil!==undefined){
					var estilBusinessId = sublayer.properties.estil.businessId;
					if (estilBusinessId === capa.estil){
						if (!map.hasLayer(sublayer)) {
							map.addLayer(sublayer);
							sublayer.activa = true;
						}else {
							map.removeLayer(sublayer);
							sublayer.activa = false;						
						}
					}
					subLayersState.push(sublayer.activa);
				}
				else {
					if (sublayer.properties!==undefined && sublayer.properties.codiEstil!==undefined) {
						var estilBusinessId = sublayer.properties.codiEstil;
						if (estilBusinessId === capa.estil){
							if (!map.hasLayer(sublayer)) {
								map.addLayer(sublayer);
								sublayer.activa = true;
							}else {
								map.removeLayer(sublayer);
								sublayer.activa = false;						
							}
						}
						subLayersState.push(sublayer.activa);
					}
				}
				
			}
			
			var totesOff = subLayersState.every(function(sublayer) {
				return !sublayer;
			});
			if (totesOff) {
				currentLayer.activa = false;
			}else{
				currentLayer.activa = true;
			}
			
			$.publish('updateVisualitzacioLeafletLayer', {layers: self.layers});
			return self;
		},

		_waitLoadAll: function(numLayers){
			var self = this;
			if(self.numLayers === numLayers){
				var layersToSend = self.layers.map(function(layer) {
					return {businessId: layer.businessId, name: layer.name};
				});
				$.publish('updateVisualitzacioLeafletLayer', {layers: self.layers});
				self.waitDeferred.resolve();
			}
			return self;
		},
		
		_loadOrigenWMS: function(_mapConfig, _controlCapes){
			var dfd = $.Deferred(),
			layer_map = {origen:[],sublayers:[]};
			
			$.each(_mapConfig.servidorsWMS, function(index, value){
				//TODO parsear las options y el group y dejarlo en json.
				//TODO quitar el parse de cada tipo de capa.
				if(value.options && value.capesGroup){
					var options = InstamapsUtils.Dom.cleanOptions(value.options);
					
					var group = JSON.parse(value.capesGroup);
					options.group = group;
					value.options = JSON.stringify(options);
				}
				if(value.capesOrdre == capesOrdre_sublayer){
					layer_map.sublayers.push(value);
					lsublayers.push(value); //variable global se tendría que quitar
				}else{
					layer_map.origen.push(value);
				}
			});

			$.each(layer_map.origen, function(index, value){
				var jsonOptions = InstamapsUtils.Dom.cleanOptions(value.options);
				
				if(jsonOptions && jsonOptions.group){
					if(_controlCapes){
						_controlCapes._addGroupFromObject(jsonOptions.group);
					}
				}
			});

			dfd.resolve(layer_map); 
			return dfd.promise();
		},

		getVisibleLayers: function(includeVisualizations){
			var self = this;
			var visibles = [];
			var layers = self.layers;
			var bIncludeVis = includeVisualizations || false;
			for(var i=0, len=layers.length; i<len; ++i){
				var layer = layers[i];
				if (layer.activa && !layer.sublayer){
					visibles.push(layer);
				}else if(layer.activa && layer.sublayer ){
					var origen = layer.origen;
					if (origen===undefined && layer.layer!=undefined && layer.layer.options!=undefined) origen = layer.layer.options.origen;
					if (!self._isActiveParent(origen)) {
						var parent = self._getLayerByBussinesId(origen);
						if(parent && -1 === $.inArray(parent, visibles)){
							visibles.push(parent);
						}
					}
				}else if(layer.activa && layer.sublayer && bIncludeVis){
					visibles.push(layer);
				}
			}
			return visibles;
		},

		_isActiveParent: function(layerBussinesid){
			var self = this;
			var layers = self.layers;
			var isActive = false;
			$.each(layers, function(index, value){
 				if(value.layer){
 					if(layerBussinesid === value.businessId){
 						isActive = value.activa;
 					}
 				}
 			});
 			return isActive;
		},

		_getLayerByBussinesId: function(layerBussinesid){
			var self = this;
			var layers = self.layers;
			var layer = null;
			$.each(layers, function(index, value){
				if(value.layer){
 					if(layerBussinesid === value.businessId){
 						layer = value;
 					}
 				}
			});
			return layer;	
		},

		_listenEvents: function(){
			var self = this;
			$.subscribe('toggleCapa',self._toggleLayer.bind(self));
			$.subscribe('toggleSubCapa',self._toggleSubCapa.bind(self));
		}
	};
	
	InstamapsLayers.init = function(options){
		var self = this;
		self = $.extend(self, layersOptions, options);
		self._listenEvents();
	};
	
	InstamapsLayers.init.prototype = InstamapsLayers.prototype;
	
	global.InstamapsLayers = InstamapsLayers;
	
}(window, jQuery));
